import React, { useMemo } from "react";
import { useParams } from "react-router";
import { LiveEventDetailsView } from "./view";
import { useSelector } from "react-redux";
import { getEventData } from "features/shared-event/redux/selectors";

export const LiveEventDetails = () => {
  const { hash } = useParams();
  const eventData = useSelector(getEventData);

  const eventProps = useMemo(() => {
    if (eventData) {
      return {
        eventName: eventData.activation_name,
        liveLinks: eventData.live_links,
        notes: eventData.notes,
        eventDate: eventData.activation_starts_at,
        eventImages: eventData.image_urls,
      };
    } else {
      location.href = `/share/${hash}`;
    }
  }, [eventData]);

  return <LiveEventDetailsView {...eventProps} />;
};
